import { connect } from 'react-redux';
import Citations from './Citations';
import {
    getCitationSearchConfiguredFormBegin,
    applyCitationFilters,
    setCitationFilterSelections,
} from '../../store/actions/citation.actions';

import {
    getCitationList,
    getCitationListLoading,
    getLoadMore,
    getCitationsCount,
    getCitationSearchForm,
    getCitationSearchFormLoadingStatus,
    getCitationFilterSelections,
} from '../../store/selectors/citation.selectors';

const mapStateToProps = (state: any) => {
    const citationList = getCitationList(state);
    const isLoading = getCitationListLoading(state);
    const hasMore = getLoadMore(state);
    const citationCount = getCitationsCount(state);
    const citationSearchForm = getCitationSearchForm(state);
    const isCitationSearchFormLoading = getCitationSearchFormLoadingStatus(state);
    const filterSelections = getCitationFilterSelections(state);
    return {
        citationList,
        isLoading,
        hasMore,
        citationCount,
        citationSearchForm,
        isCitationSearchFormLoading,
        filterSelections,
    };
};

const mapDispatchToProps = {
    applyCitationFilters,
    getCitationSearchForm: getCitationSearchConfiguredFormBegin,
    setFilterSelections: setCitationFilterSelections,
};

export default connect(mapStateToProps, mapDispatchToProps)(Citations);
